import { IconWrapper } from '../runtime';
export default IconWrapper('add-comment', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6 6.99951H8M8 6.99951H10M8 6.99951V8.99976M8 6.99951V4.99976M3.25 12.2627C2.42157 12.2627 1.75 11.5911 1.75 10.7627L1.75024 3.24951C1.75024 2.42108 2.42181 1.74951 3.25024 1.74951H12.7502C13.5787 1.74951 14.2502 2.42108 14.2502 3.24951L14.25 10.7627C14.25 11.5911 13.5784 12.2627 12.75 12.2627H8.7822L6.26073 14.8166C6.0723 15.0074 5.74725 14.874 5.74725 14.6058V12.2627H3.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});